import React, { Component } from 'react';

// A page import/render failure must leave the layout and its navigation usable.
class PageErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error('Page failed to load or render.', error, info);
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="page-loading page-error" role="alert">
          <p>Could not load this page</p>
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default PageErrorBoundary;
